var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component content-btn"},[_c('a',{ref:"text",attrs:{"href":_vm.href,"target":_vm.target}},[_c('span',{ref:"span"}),_vm._v(" "),_c('span',{staticClass:"comb"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }